import { render, staticRenderFns } from "./addConent.vue?vue&type=template&id=330a0040&scoped=true"
import script from "./addConent.vue?vue&type=script&lang=js"
export * from "./addConent.vue?vue&type=script&lang=js"
import style0 from "./addConent.vue?vue&type=style&index=0&id=330a0040&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a0040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330a0040')) {
      api.createRecord('330a0040', component.options)
    } else {
      api.reload('330a0040', component.options)
    }
    module.hot.accept("./addConent.vue?vue&type=template&id=330a0040&scoped=true", function () {
      api.rerender('330a0040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/attendance/setting/addConent.vue"
export default component.exports